<div class="bg-slate-50">
  <div class="container mx-auto">
    <div class="grid pt-5 pb-9 px-2 [&>div]:shadow-lg  [&>div]:p-2 [&>div]:bg-white gallery-wrapper">
      <ng-image-slider #nav [images]="imageObject" [infinite]="false" slideImage="1" [showArrow]="false">
      </ng-image-slider>
    </div>
  </div>
</div>
